import React, { FC } from 'react';
import { withRouter } from 'next/router';
import { WithRouterProps } from 'next/dist/client/with-router';
import get from 'lodash/get';

import getDefaultTopicUrl from 'utils/getDefaultTopicUrl';

import { Breadcrumb } from 'styled';
import { ArticleTitle, Container } from './style';

import Language from 'constants/Language';
import { RouteMap } from 'constants/Routes';
import { Color } from 'styled/theme/colors';

import { Article, OrganizedTopic, Topic } from 'types';

interface PassedProps {
  className?: string;
  article: Article | null;
  organizedTopics: OrganizedTopic;
  paramsWithRoot: string[];
  slicedParams: string[];
  showContentHubLandingListItem: boolean; // "Learn"
  textColor: Color;
}

export type Props = WithRouterProps & PassedProps;

const Breadcrumbs: FC<Props> = (props) => {
  const {
    className,
    article,
    organizedTopics,
    paramsWithRoot,
    slicedParams,
    showContentHubLandingListItem,
    textColor,
    router,
  } = props;

  return (
    <Container as="ol" className={className}>
      {showContentHubLandingListItem && (
        <Breadcrumb
          textColor={textColor}
          to={RouteMap.CONTENT_HUB_LANDING.path}
          label={Language.t('Breadcrumbs.rootLabel')}
          ariaLabel={Language.t('Global.pageButtonAriaLabel', {
            title: RouteMap.CONTENT_HUB_LANDING.path,
          })}
          disabled={router.asPath === RouteMap.CONTENT_HUB_LANDING.path}
          showArrow={router.asPath !== RouteMap.CONTENT_HUB_LANDING.path}
        />
      )}

      {paramsWithRoot.map((topic, index) => {
        const nextSelectedTopic: Topic = get(
          organizedTopics,
          `topicsBySlug./${paramsWithRoot[index + 1]}`
        );
        const nextChildTopic: Topic[] = get(
          organizedTopics,
          `topicsByParentSlug./${paramsWithRoot[index + 1]}`,
          []
        );
        const currentTopicSlug = get(router, 'query.contentHubSlugs', []).slice(
          -1
        )[0];
        const isCurrentPage =
          get(nextSelectedTopic, 'slug', '') === `/${currentTopicSlug}`;

        if (index + 1 === paramsWithRoot.length && !nextSelectedTopic) {
          return null;
        }

        if (!slicedParams.includes(topic)) return null;

        return (
          <Breadcrumb
            key={topic}
            textColor={textColor}
            to={getDefaultTopicUrl(organizedTopics, nextSelectedTopic.slug)}
            label={nextSelectedTopic.title}
            ariaLabel={Language.t('Global.pageButtonAriaLabel', {
              title: nextSelectedTopic.title,
            })}
            disabled={(!nextChildTopic.length && !article) || isCurrentPage}
            showArrow={!!article || paramsWithRoot.length - 2 !== index}
            isActive={isCurrentPage}
          />
        );
      })}

      {!!article && (
        <ArticleTitle as="li" overflowX="hidden" textColor={textColor}>
          {article.seo.keywords[0] || article.title}
        </ArticleTitle>
      )}
    </Container>
  );
};

export default withRouter(Breadcrumbs);
